import { getLocales, getLocale } from '@raisin/cp-utils';
import { AnyLocale, AnyLocaleSchema, AppLocale, AppLocaleSchema } from './types';

const appLocales = getLocales() as AppLocale[];

const toAppLocale = (locale: AnyLocale): AppLocale => {
  const safeAppLocale = AppLocaleSchema.safeParse(locale);
  if (safeAppLocale.success) {
    return safeAppLocale.data;
  }
  return appLocales.find((appLocale) => getLocale(appLocale).cmsFormat === locale)!;
};

/**
 * receives a locale which confirms to both CsLocale and AppLocale, and transform it to AppLocale
 * @param locale any value from AnyLocale
 * @returns AppLocale and null if input is invalid
 */
const parseAnyLocale = (locale: AnyLocale): AppLocale | null => {
  const parsed = AnyLocaleSchema.transform(toAppLocale).safeParse(locale);
  if (!parsed.success) {
    return null;
  }
  return parsed.data;
};

export default parseAnyLocale;
